export enum ReconciliateTop {
  EXIST = 'EXIST',
  IDENTITY = 'IDENTITY',
}
